import sitePagesData from "./site-pages.json";
import { SEO_DATA } from "../utils/constants-seo";

export type LlmsSection = "Leistungen" | "Praxis" | "Kontakt" | "Optional";

export type SeoPageKey = keyof typeof SEO_DATA;

export interface SitePageEntry {
  path: string;
  seoKey: SeoPageKey;
  label: string;
  llmsSection: LlmsSection;
  llmsDescription: string;
  contentFile?: string;
  indexable: boolean;
  sitemapPriority?: number;
  sitemapChangefreq?: "weekly" | "monthly" | "yearly";
  relatedPaths?: string[];
}

export const SITE_PAGES: SitePageEntry[] = sitePagesData as SitePageEntry[];

export function getSitePageByPath(path: string): SitePageEntry | undefined {
  return SITE_PAGES.find((page) => page.path === path);
}

export function getIndexablePages(): SitePageEntry[] {
  return SITE_PAGES.filter((page) => page.indexable);
}

export function getLlmsPagesBySection(section: LlmsSection): SitePageEntry[] {
  return SITE_PAGES.filter((page) => page.indexable && page.llmsSection === section);
}

export function getMarkdownPathForRoute(routePath: string): string {
  if (routePath === "/") return "index.md";
  return `${routePath.slice(1)}.md`;
}

export function getPublicMarkdownUrl(baseUrl: string, routePath: string): string {
  return `${baseUrl}/${getMarkdownPathForRoute(routePath)}`;
}
